/** Global search (tracker item 61): GET /api/search. */

/** Searchable entity types, in the order the backend returns their groups. */
export type GlobalSearchEntityType = 'customer' | 'property' | 'job' | 'invoice' | 'payment' | 'estimate';

/** One result line. `customerId` is set for every type but customers (the property route needs it). */
export interface GlobalSearchResult {
  type: GlobalSearchEntityType;
  id: string;
  title: string;
  subtitle: string;
  customerId: string | null;
  /** The record's route in this app, e.g. /customers/<id>/properties/<id> */
  path: string;
}

export interface GlobalSearchGroup {
  type: GlobalSearchEntityType;
  label: string;
  results: GlobalSearchResult[];
}

export interface GlobalSearchResponse {
  /** The query as searched (trimmed, whitespace collapsed) */
  query: string;
  limit: number;
  /** The types searched for the signed-in user's role */
  types: GlobalSearchEntityType[];
  /** One group per searched type, empty groups included */
  groups: GlobalSearchGroup[];
}

export interface GlobalSearchOptions {
  /** Results per type, 1-20 (backend default 5) */
  limit?: number;
  /** Narrow to these types (never wider than the role allows) */
  types?: GlobalSearchEntityType[];
}

/** Shortest query the backend searches (shorter queries are a 400). */
export const GLOBAL_SEARCH_MIN_LENGTH = 2;
